module.exports = __webpack_public_path__ + "img/olympique-lyonnais-logo-icon.043647af.png";